import cn from 'clsx'

import styles from './status.css'

export const getSharingStatusString = (status: string) => {
  switch (status) {
    case 'INCOMPLETE':
      return 'Private use only'
    case 'ACTIVE':
      return 'Fully monetizable'
    case 'INVALID':
      return 'Invalid license'
    case 'TERMINATED':
      return 'License terminated'
    default:
      return 'Private use only'
  }
}

const getClassName = (status: string) => {
  switch (status) {
    case 'INCOMPLETE':
      return styles.limited
    case 'ACTIVE':
      return styles.active
    case 'INVALID':
      return styles.invalid
    case 'TERMINATED':
      return styles.terminated
    default:
      return styles.unlicensed
  }
}

export const Version = ({ size, invertedVersion }: { size?: 'small' | 'medium' | 'large'; invertedVersion?: boolean }) => (
  <div className={cn(styles.version, styles[size], invertedVersion ? styles.versionInverted : styles.versionDefault)}>Version</div>
)

type StatusProps = {
  status: string
  isVersion?: boolean
  invertedVersion?: boolean
  hideSharing?: boolean
  size?: 'small' | 'medium' | 'large'
  className?: string
  wrapperClassName?: string
}

const Status = ({
  status,
  isVersion,
  invertedVersion,
  hideSharing = false,
  size,
  className,
  wrapperClassName,
}: StatusProps): JSX.Element => {
  return (
    <div className={cn(styles.statusWrapper, wrapperClassName)}>
      <span className={cn(getClassName(status), styles.badge, styles[size], className)}>{status?.toLowerCase()}</span>
      {isVersion && <Version size={size} invertedVersion={invertedVersion} />}
      {!hideSharing && <span className={styles.sharing}>{getSharingStatusString(status)}</span>}
    </div>
  )
}

export default Status
